import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import { HelmetProvider } from 'react-helmet-async';
import store from "./redux/index.jsx";
import IframeProtections from './component/IframeProtections.jsx';
import { applyLanguageFromUrl } from './utils/language';

applyLanguageFromUrl();

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        <IframeProtections>
          <App />
        </IframeProtections>
      </Provider>
    </BrowserRouter>
  </HelmetProvider>
  // </React.StrictMode>,
)
